//
// Copyright 2025 DXOS.org
//

import * as Plugin from '@dxos/app-framework/Plugin';

import config from '../dx.config';

export const meta = Plugin.getMetaFromConfig(config);
